export const ACTUAL_FETCH_REPORTING_PERIODS_BEGIN = 'ACTUAL_FETCH_REPORTING_PERIODS_BEGIN';
export const ACTUAL_FETCH_REPORTING_PERIODS_SUCCESS = 'ACTUAL_FETCH_REPORTING_PERIODS_SUCCESS';
export const ACTUAL_FETCH_REPORTING_PERIODS_FAILURE = 'ACTUAL_FETCH_REPORTING_PERIODS_FAILURE';
export const ACTUAL_FETCH_REPORTING_PERIODS_DISMISS_ERROR = 'ACTUAL_FETCH_REPORTING_PERIODS_DISMISS_ERROR';
export const ACTUAL_FETCH_CONTROL_ACCOUNTS_BEGIN = 'ACTUAL_FETCH_CONTROL_ACCOUNTS_BEGIN';
export const ACTUAL_FETCH_CONTROL_ACCOUNTS_SUCCESS = 'ACTUAL_FETCH_CONTROL_ACCOUNTS_SUCCESS';
export const ACTUAL_FETCH_CONTROL_ACCOUNTS_FAILURE = 'ACTUAL_FETCH_CONTROL_ACCOUNTS_FAILURE';
export const ACTUAL_FETCH_CONTROL_ACCOUNTS_DISMISS_ERROR = 'ACTUAL_FETCH_CONTROL_ACCOUNTS_DISMISS_ERROR';
export const ACTUAL_SAVE_ACTUAL_COST_BEGIN = 'ACTUAL_SAVE_ACTUAL_COST_BEGIN';
export const ACTUAL_SAVE_ACTUAL_COST_SUCCESS = 'ACTUAL_SAVE_ACTUAL_COST_SUCCESS';
export const ACTUAL_SAVE_ACTUAL_COST_FAILURE = 'ACTUAL_SAVE_ACTUAL_COST_FAILURE';
export const ACTUAL_SAVE_ACTUAL_COST_DISMISS_ERROR = 'ACTUAL_SAVE_ACTUAL_COST_DISMISS_ERROR';
export const ACTUAL_DELETE_ACTUAL_COST_BEGIN = 'ACTUAL_DELETE_ACTUAL_COST_BEGIN';
export const ACTUAL_DELETE_ACTUAL_COST_SUCCESS = 'ACTUAL_DELETE_ACTUAL_COST_SUCCESS';
export const ACTUAL_DELETE_ACTUAL_COST_FAILURE = 'ACTUAL_DELETE_ACTUAL_COST_FAILURE';
export const ACTUAL_DELETE_ACTUAL_COST_DISMISS_ERROR = 'ACTUAL_DELETE_ACTUAL_COST_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/actual/redux/constants.js